import { Input } from 'antd'

export const CustomInput = ({ type = 'text', ...props }) => {
  const inputStyle = {
    fontSize: '12px'
  }
  
  if (type === 'password') {
    return <Input.Password style={inputStyle} {...props} />
  }
  return <Input style={inputStyle} {...props} />
}